// Utility functions for subscription components

// Format a date object to DD/MM/YYYY format
export const convertDate = (dateString) => {
  if (!dateString) {
    return 'Not available';
  }
  try {
    // Check if the date is in the database format DD/MM/YYYY HH:MM:SS
    if (typeof dateString === 'string' && dateString.includes('/')) {
      const [datePart, timePart] = dateString.split(' ');
      const [day, month, year] = datePart.split('/');
      if (day && month && year) {
        // Create date in the format YYYY-MM-DD
        dateString = `${year}-${month}-${day}${timePart ? ' ' + timePart : ''}`;
      }
    }
    
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return 'Invalid date';
    }
    
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  } catch (error) {
    console.error("Error converting date:", error);
    return 'Error processing date';
  }
};

// Calculate the next billing date based on the billing cycle
export const calculateNextBillingDate = (dateString, billingCycle) => {
  try {
    // Handle database date format (DD/MM/YYYY HH:MM:SS)
    let startDate;
    let originalDayFromString = null;
    
    if (typeof dateString === 'string' && dateString.includes('/')) {
      const [datePart, timePart] = dateString.split(' ');
      const [day, month, year] = datePart.split('/');
      
      // Store the exact day from the string to preserve it
      originalDayFromString = parseInt(day, 10);
      
      if (day && month && year) {
        // Convert DD/MM/YYYY to YYYY-MM-DD for proper date parsing
        const formattedDateStr = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}${timePart ? ' ' + timePart : ''}`;
        startDate = new Date(formattedDateStr);
      } else {
        startDate = new Date(dateString);
      }
    } else {
      // If not in the database format, use standard date parsing
      startDate = dateString ? new Date(dateString) : new Date();
    }
    
    // If the date is invalid, use current date
    if (isNaN(startDate.getTime())) {
      startDate = new Date();
    }
    
    // Get the original day of month to preserve
    // If we have the exact day from the string, use that instead of the JavaScript date object's day
    const originalDay = originalDayFromString || startDate.getDate();
    const originalMonth = startDate.getMonth();
    const originalYear = startDate.getFullYear();
    
    // Create a date using the exact original day
    let nextDate;
  
  // Adjust based on billing cycle
  if (billingCycle) {
    const cycle = billingCycle.toLowerCase();
    if (cycle === 'yearly' || cycle === 'annual') {
        nextDate = new Date(originalYear + 1, originalMonth, originalDay); // Add 1 year
    } else if (cycle === 'quarterly') {
        nextDate = new Date(originalYear, originalMonth + 3, originalDay); // Add 3 months
      } else if (cycle === 'semi-annually') {
        nextDate = new Date(originalYear, originalMonth + 6, originalDay); // Add 6 months
      } else if (cycle === 'monthly') {
        nextDate = new Date(originalYear, originalMonth + 1, originalDay); // Add 1 month
    } else if (cycle === 'weekly') {
        nextDate = new Date(startDate.getTime() + (7 * 24 * 60 * 60 * 1000)); // Add 7 days
    } else if (cycle === 'daily') {
        nextDate = new Date(startDate.getTime() + (24 * 60 * 60 * 1000)); // Add 1 day
      } else {
        // Default to monthly if cycle is unrecognized
        nextDate = new Date(originalYear, originalMonth + 1, originalDay);
      }
    } else {
      // Default to monthly if no cycle provided
      nextDate = new Date(originalYear, originalMonth + 1, originalDay);
    }
    
    // Format the date as DD/MM/YYYY
    const finalDay = String(originalDay).padStart(2, '0');
    const finalMonth = String(nextDate.getMonth() + 1).padStart(2, '0');
    const finalYear = nextDate.getFullYear();
    
    return `${finalDay}/${finalMonth}/${finalYear}`;
  } catch (error) {
    return 'Error processing date';
  }
};

// Capitalize first letter of each word
export const capitalizeFirstLetter = (string) => {
  if (!string) return '';
  return string
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}; 